import React, { useRef } from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";

import { ReactComponent as InfoIcon18 } from "../../icons/icon/18/a-icon-info-18.svg";
import { ReactComponent as IconExternal24 } from "../../icons/icon/24/a-icon-externallink-24.svg";
import Button from "../button/button";
import TextLightbox from "../lightbox/textLightbox";

import "./logoTile.scss";

const LogoTile = ({
  logo,
  description = null,
  name,
  url = "",
}) => {
  const lightbox = useRef();

  return (
    <>
      <Button
        variant="plain-grey"
        className="logo-tile"
        onClick={() => {
          lightbox?.current?.show();
        }}
        disabled={!(description || url)}
      >
        {logo}
        {(description || url) && (
          <div className="logo-tile__info-icon">
            <InfoIcon18 />
          </div>
        )}
      </Button>
      {(description || url) && (
        <TextLightbox
          ref={lightbox}
          title={name}
        >
          <p>{description}</p>
          {url && (
            <Button href={url} className="mt-6 mt-xl-12">
              <FormattedMessage id="partner.go_to_website" />
              <IconExternal24 className="ml-12" />
            </Button>
          )}
        </TextLightbox>
      )}
    </>
  );
};

LogoTile.propTypes = {
  description: PropTypes.node,
  logo: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
};

export default LogoTile;
